export default function form() {
    const form = document.querySelector(".main-opportunity__form");
    const thanks = document.querySelector(".main-opportunity__thanks");
    const formText = document.querySelector(".main-opportunity__image-text");

    if (!form || !thanks) return;



    async function sendAjax(formData) {
        let response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST', body: formData,
        });
        return await response.json();
    }
    
    document.querySelectorAll('.js-form')?.forEach(form => {
        form.addEventListener('submit', (e) => {
            e.preventDefault()
    
            let btn = form.querySelector('button');
    
            if (form.privacy.checked) {
                btn.innerText = 'Отправка...'
                sendAjax(new FormData(form))
                    .then(result => {
                        if (result.success) {
                            form.reset()
                            thanks.classList.add("active");

                        }
                    })
                    .finally(() => {
                        btn.innerText = 'Отправить заявку';
                        setTimeout(() => {
                            thanks.classList.remove("active");
                        }, 5000);
                    })
            }
        })
    })

}